(function (){
    'use strict';

    angular
        .module('services')
        .service('ExpoStudentService', ExpoStudentService);

    ExpoStudentService.$inject = ['$http', 'API_BASE'];

    function ExpoStudentService ($http, API_BASE) {
        var service = this;

        service.getStudentsEnrroledByLocation  = getStudentsEnrroledByLocation;
        service.getAllStudentsErrolled  = getAllStudentsErrolled;

        function getStudentsEnrroledByLocation(fields) {
            return $http.get(API_BASE + '/physicalfairs/studentsenrolledlocation', {params:fields});
        }

        function getAllStudentsErrolled(fields) {
            return $http.get(API_BASE + '/physicalfairs/allstudentsenrolled', {params:fields});
        }

    }
})();